<div class="login-page" [ngClass]=" {'login-page__light-text' : data.fontColorPicker.value === 'Light' }"
     [ngStyle]=" data.backgroundImage ? {
       'background' : 'url('+ data.backgroundImage?.value.src +')',
       'background-size' : 'cover',
       'bacakground-repeat' : 'no-repeat'}
       : '' ">

  <div class="login-page__content">
    <h1>{{data.title.value}}</h1>

    <div class="login-page__wrapper">
      <div>
        <label>Brugernavn/email</label><br />
        <input class="login-page__wrapper--input-text" type="text" name="username" placeholder="Indtast dit brugernavn/email" />
      </div>
      <div>
        <label>Adgangskode</label><br />
        <input class="login-page__wrapper--input-text" type="password" name="password" placeholder="Indtast din adgangskode" />
      </div>
      <div class="login-page__wrapper--input-button">
        <input type="submit" class="bg-green-button" value="Log ind" />
      </div>
    </div>

    <div class="login-page__options">
      <p>Er du ikke oprettet som bruger?</p>
      <p>Har du glemt din adgangskode?</p>
    </div>
  </div>

</div>
